import { render, staticRenderFns } from "./main-login-form-popup.html?vue&type=template&id=c5cd523a&scoped=true&external"
import script from "./main-login-form-popup.js?vue&type=script&lang=js&external"
export * from "./main-login-form-popup.js?vue&type=script&lang=js&external"
import style0 from "./main-login-form-popup.scss?vue&type=style&index=0&id=c5cd523a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cd523a",
  null
  
)

export default component.exports